import { SET_SYSTEM_STATE } from "../acions/types";

const initialState = { unprocessedWorkTasksCount: 0, failedMailingsCount: 0 };

export default function systemState(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case SET_SYSTEM_STATE:
      return payload;
    default:
      return state;
  }
}
